import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Informe1 from './pages/Informe1'
import Informe2 from './pages/Informe2'
import Informe3 from './pages/Informe3'
import Home from './pages/Home'
import './App.css'
import Layout from './component/Layout'

function App() {
  return (
    <Router basename={'especiales/infraestructura-natural-recuperar-fuentes-agua/'}>
      <Layout>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/resurreccion-bofedales-necesita-lima">
            <Informe1 />
          </Route>
          <Route exact path="/como-cuida-cusco-agua">
            <Informe2 />
          </Route>
          <Route exact path="/fuentes-agua-ciudades-sur-peligro">
            <Informe3 />
          </Route>
        </Switch>
      </Layout>
    </Router>
  )
}

export default App
